import type { LauncherState } from '../driver-common/state';

export interface AmeConfig {
  /**
   * Whether the whole feature of AME driver is enabled or not. It can be
   * disabled temporarily while still preserving other configuration.
   */
  enabled: boolean;

  /**
   * The absolute path of AME executable required to run the AME process.
   */
  amePath: string;

  /**
   * List of locally reachable absolute paths with a valid preset configured,
   * that are selected by the user to be watched by Mimir Desktop for .prproj
   * files.
   */
  selectedWatchFolders: string[];

  /**
   * Maximum time in seconds to wait if AME appears to be unresponsive.
   */
  timeout: number;
}

export const defaultAmeConfig: AmeConfig = {
  enabled: false,
  amePath: '',
  selectedWatchFolders: [],
  timeout: 180,
};

export const ameState: LauncherState = {
  pollingIntervalId: undefined,
  isProcessingAlready: false,
};
